import { FC, useEffect, useMemo } from 'react'
import { Form, json, replace, useActionData } from 'react-router-dom'

// COMPONENTS
import Button from '@components/atoms/button'
import TextField from '@components/atoms/textfield'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { useEmailIdContext } from '..'
import { createAction } from '@utils/actions'
import { isFailedResponse } from '@apis'
import { isEmail, isNonEmptyString } from '@utils/type-checkers'
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'
import { useInput } from '@hooks/inputs'


const Component: FC<{}> = () => {
    const resource = useLoader<typeof loader>()
    const { setToast } = useEmailIdContext()
    const emailProps = useInput()[1]
    const data = useActionData()

    useEffect(() => {
        console.log(data)
        if (data != null) setToast({ type: 'error', text: isNonEmptyString(data) ? data : 'An unexpected Error occured' });
    }, [setToast, data])

    const submittable = useMemo(() => {
        return resource.emailAddress !== emailProps.value && isEmail(emailProps.value)
    }, [resource.emailAddress, emailProps.value])

    return (
        <Form className="flex flex-col" style={{ gap: 'inherit' }} method="POST">
            <h4>Update E-mail Address</h4>
            <p className="text-body text-color-500"><strong>Current email:</strong> {resource.emailAddress}</p>
            <TextField {...emailProps} type="email" name="email" placeholder="E-mail Address" autoComplete="email" required />
            <Button type="submit" theme="primary" disabled={!submittable}>Continue</Button>
        </Form>
    )
}

const loader = createAuthenticatedLoader(async ({ params }, Clerk) => {
    const emailId = params['emailId'] || ''
    const resource = Clerk.user?.emailAddresses.find(({ id }) => id === emailId)

    if (!!resource) return resource
    else return replace('/account/profile')
})

const action = createAction(async ({ request, params }) => {
    try {
        const emailId = params['emailId'] || ''

        const data = await request.formData()
        const user = window.Clerk?.user
        const email = data.get('email')
        if (!isEmail(email) || !user) throw new Error(`${email} is formatted incorrectly`)

        // Create the new email address and set as the primary
        const resource = await user.createEmailAddress({ email })

        // Delete the previous email from the user
        const previousResource = user?.emailAddresses.find(({ id }) => id === emailId)
        if (previousResource) await previousResource.destroy()

        return replace(`/account/profile/email/${resource.id}/verify`)
    } catch (error) {
        console.error(error)
        if (isFailedResponse(error) || error instanceof Error) return json(error.message);
        else return json('An unexpected Error occured')
    }
})

const UpdateEmailRoute: RouteObject = {
    path: 'update',
    Component,
    loader,
    action,
}

export { UpdateEmailRoute } 
